/* FL Boxy — karta boxa (snippets/fl-boxy-card.liquid), wspólna dla półki i Boxomatu.
   1. Najechanie myszą na zdjęcie paczki buja wiszącą etykietą — ruch kończy się sam, nawet gdy
      kursor zjedzie niżej; najechanie na samą etykietę nic nie robi.
   2. Po dodaniu do koszyka przez product-form motywu (szuflada koszyka, licznik w nagłówku)
      przycisk na chwilę pokazuje „Dodano do koszyka”. */
(() => {
  'use strict';

  if (customElements.get('fl-boxy-card')) return;

  const SWING = [
    { rotate: '0deg' },
    { rotate: '2.4deg', offset: 0.2 },
    { rotate: '-1.7deg', offset: 0.45 },
    { rotate: '.7deg', offset: 0.7 },
    { rotate: '0deg' }
  ];

  class FLBoxyCard extends HTMLElement {
    constructor() {
      super();
      // Nasłuch na samym elemencie: działa też po przestawieniu karty (FLIP) i po sklonowaniu do wyniku Boxomatu.
      this.addEventListener('pointerover', (e) => this.onPointerOver(e));
      this.addEventListener('on:cart:add', () => this.markAdded());
      this.addEventListener('on:line-item:change', () => this.markAdded());
    }

    onPointerOver(e) {
      if (e.pointerType !== 'mouse' || !e.target || !e.target.closest) return;
      const stage = e.target.closest('.fl-boxy-card__stage');
      if (!stage || !this.contains(stage)) return;
      if (e.relatedTarget && stage.contains(e.relatedTarget)) return;
      const label = this.querySelector('.fl-boxy-card__label');
      if (!label || typeof label.animate !== 'function' || label.getAnimations().length) return;
      label.animate(SWING, { duration: 1150, easing: 'cubic-bezier(.2,.8,.2,1)' });
    }

    markAdded() {
      const btn = this.querySelector('button[name="add"]');
      const label = btn && btn.querySelector('.fl-boxy-btn__label');
      if (!btn || !label) return;
      const text = btn.dataset.addedText;
      if (!this.atcText) this.atcText = label.textContent;
      btn.classList.add('is-added');
      if (text) label.textContent = text;
      clearTimeout(this.addedTimer);
      this.addedTimer = setTimeout(() => {
        btn.classList.remove('is-added');
        label.textContent = this.atcText;
      }, 3200);
    }
  }

  customElements.define('fl-boxy-card', FLBoxyCard);
})();
